<template>
  <component :is="tag">
    <h2 v-if="blok.text" class="blok-heading size-l unbold section-inner section-contained">
      {{ blok.text }}
    </h2>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.blok-heading {
  text-align: center;
}
</style>
